// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ypMc","footer":"ModalUpdate_footer__2qVbt"};